import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var RadioDut;
(function (RadioDut) {
    let Flags;
    (function (Flags) {
        Flags[Flags["NOT_TREATMENT"] = 1] = "NOT_TREATMENT";
        Flags[Flags["ALWAYS"] = 2] = "ALWAYS";
        Flags[Flags["IGNITION_ON"] = 4] = "IGNITION_ON";
        Flags[Flags["ACCELEROMETER_ON"] = 8] = "ACCELEROMETER_ON";
        // Пользовательские настройки
    })(Flags = RadioDut.Flags || (RadioDut.Flags = {}));
    function isNotTreatment(radio_dut) {
        return isFlagSet(radio_dut, Flags.NOT_TREATMENT);
    }
    RadioDut.isNotTreatment = isNotTreatment;
    function setNotTreatment(radio_dut, enabled) {
        return setFlag(radio_dut, Flags.NOT_TREATMENT, enabled);
    }
    RadioDut.setNotTreatment = setNotTreatment;
    function isAlways(radio_dut) {
        return isFlagSet(radio_dut, Flags.ALWAYS);
    }
    RadioDut.isAlways = isAlways;
    function setAlways(radio_dut, enabled) {
        return setFlag(radio_dut, Flags.ALWAYS, enabled);
    }
    RadioDut.setAlways = setAlways;
    function isIgnitionOn(radio_dut) {
        return isFlagSet(radio_dut, Flags.IGNITION_ON);
    }
    RadioDut.isIgnitionOn = isIgnitionOn;
    function setIgnitionOn(radio_dut, enabled) {
        return setFlag(radio_dut, Flags.IGNITION_ON, enabled);
    }
    RadioDut.setIgnitionOn = setIgnitionOn;
    function isAccelerometerOn(radio_dut) {
        return isFlagSet(radio_dut, Flags.ACCELEROMETER_ON);
    }
    RadioDut.isAccelerometerOn = isAccelerometerOn;
    function setAccelerometerOn(radio_dut, enabled) {
        return setFlag(radio_dut, Flags.ACCELEROMETER_ON, enabled);
    }
    RadioDut.setAccelerometerOn = setAccelerometerOn;
    RadioDut.get = createAccessors(arrayGetSet('radio_duts'), {
        serial: '',
        type: 6,
        name: 'РадиоДУТ',
        setting_register: 1,
        no_connection_timeout: 2.0,
        rol_connection_lost: [],
        related_radiomodule_id: -1,
        calibration: 0,
        egts: 0,
        common_with: [],
        config: 0,
    });
})(RadioDut || (RadioDut = {}));
